
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { map, startWith } from 'rxjs/operators';
import { Component, Input, OnInit, forwardRef, ViewChild, AfterViewInit, ChangeDetectorRef, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';




@Component({
    selector: 'app-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AutocompleteComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AutocompleteComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  myControl = new FormControl<string | null>(null);
  @Input() options: string[] = [];
  @Input() name?: string;
  @Input() id?: string;
  @Input() class?: string;
  @Input() placeholder?: string;
  @ViewChild('inputControl',) inputControl!: ElementRef;
  hasFocus = false;
  @Input('hasFocus') set setHasFocus(hasFocus: boolean) {
    this.hasFocus = hasFocus;

    // if (hasFocus && this.inputControl) {
    //   this.inputControl.nativeElement.focus();
    // }
  }

  constructor(private cd: ChangeDetectorRef) { }
  value = '';

  filteredOptions!: Observable<string[]>;
  private propagateChange: (value: string | null) => void = () => {};
  private propagateTouched: () => void = () => {};

  click($event: Event) {
    $event.stopPropagation();
    $event.preventDefault();
  }
  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(null),
      map((val: string | null) => val ? this.filter(val) : this.options.slice()));
    this.myControl.setValue(this.value || null);
  }

  ngAfterViewInit() {
    if (this.hasFocus && this.inputControl) {
      this.inputControl.nativeElement.focus();
      setTimeout(() => {
        this.inputControl.nativeElement.select();
      });

      this.cd.detectChanges();
    }
  }

  filter(val: string): string[] {
    return this.options.filter(
      (option: string) =>
        option.toLowerCase().indexOf(val.toLowerCase()) === 0);
  }

  trySelect() {

    const filter = this.options.filter((option: string) => option.toLowerCase() === this.myControl.value?.toLowerCase());

    if (filter.length) {
      this.value = filter[0];
      this.propagate();
    }
  }

  onOptionSelected($event: MatAutocompleteSelectedEvent) {
    const newValue = this.options.find((option: string) => option === $event.option.value);
    if (newValue !== undefined && newValue !== this.value) {
      this.value = newValue;
      this.propagate();
    }
  }

  onBlur() {
    this.trySelect();
    this.propagateTouched();
  }

  propagate() {
    this.propagateChange(this.value);
  }

  writeValue(value: string | null | undefined) {
    this.value = value ?? '';
    this.myControl.setValue(this.value || null);

  }
  registerOnChange(fn: (value: string | null) => void) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: () => void) {
    this.propagateTouched = fn;
  }


}
